module.exports = __webpack_public_path__ + "static/img/fire@2x.24b049f0.png";